import { Instance, SnapshotOut, types } from "mobx-state-tree"

export const ExchangeBaseModel = types
  .model("exchange")
  .props({
    id: types.maybe(types.number),
    ex_order_no: types.maybe(types.string),
    order_status: types.maybe(types.number),
    ex_amount: types.maybe(types.number),
    amount: types.maybe(types.number),
    rate: types.maybe(types.number),
    usdt_trc: types.maybe(types.string),
    username: types.maybe(types.string),
    expired_at: types.maybeNull(types.Date),
    created: types.maybeNull(types.Date),
    cancelled_at: types.maybeNull(types.Date),
  })
  .actions((self) => ({
    update(values: { [key: string]: any }) {
      for (const key in values) {
        self[key] = values[key]
      }
    },
  }))
export const ExchangeModel = types.snapshotProcessor(ExchangeBaseModel, {
  preProcessor(sn: SnapshotOut<typeof ExchangeBaseModel>) {
    return {
      ...sn,
      expired_at: sn.expired_at ? new Date(sn.expired_at as any).valueOf() : sn.expired_at,
      created: sn.created ? new Date(sn.created as any).valueOf() : sn.created,
      cancelled_at: sn.cancelled_at ? new Date(sn.cancelled_at as any).valueOf() : sn.cancelled_at,
    }
  },
  postProcessor(sn) {
    return sn
  },
})

type ExchangeType = Instance<typeof ExchangeModel>
export interface Exchange extends ExchangeType {}
type ExchangeSnapshotType = SnapshotOut<typeof ExchangeModel>
export interface ExchangeSnapshot extends ExchangeSnapshotType {}
